import React from 'react';
import '../pages/features.css';
import Header from '../components/Home/Header';
import ProfileScreen from '../components/profile/ProfileScreen';

const Profile = () => {
  return (
    <div>
        <Header/>
        <ProfileScreen/>
    </div>
  )
}

export default Profile;
